import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let regions = [];

function RegionDropDown({ adData, getFocusRegion, theFocusRegion }) {
	const [focusRegion, setFocusRegion] = React.useState(theFocusRegion);
	const [allRegions, setAllRegions] = React.useState([]);
	// console.log(adData);
	React.useEffect(() => {
		console.log("regionDropDown.js useEffect ", theFocusRegion);
		// console.log(theFocusCampaign, theFocusRegion, theFocusAdSize);

		var regions = [];
		adData.map((ad) => {
			regions.push(ad.region);
		});
		regions = [...new Set(regions)];
		setAllRegions(regions);
	}, [adData, theFocusRegion]);

	const handleChange = (event) => {
		console.log("handleChange", event.target.value);
		//send event.target.value to app.js
		getFocusRegion(event.target.value);
		const {
			target: { value }
		} = event;
		setFocusRegion(value);
	};

	return (
		<div>
			<FormControl sx={{ m: 1, width: 300 }}>
				<InputLabel id="demo-multiple-checkbox-label">Region</InputLabel>
				<Select
					labelId="demo-multiple-checkbox-label"
					id="demo-multiple-checkbox"
					single="true"
					value={theFocusRegion ? theFocusRegion : focusRegion}
					onChange={handleChange}
					input={<OutlinedInput label="Region" />}
					renderValue={(selected) => selected}
					MenuProps={MenuProps}
				>
					{allRegions.map((region) => {
						// console.log("Region:", region, "FocusRegion:", focusRegion);
						return (
							<MenuItem key={region} value={region}>
								<Checkbox checked={focusRegion == region} />

								<ListItemText primary={region} />
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</div>
	);
}
export default RegionDropDown;
